import store from '@/state/store'


export default [
  {
    path: '/',
    name: 'influencer_home',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['overview/hasOverviewData']) {
          await store.dispatch('overview/getOverviewData');
        }
        next();
      }
    },
    component: () => import('./views/overview/overview'),
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (true || !store.getters['campaign/hasCampaignsData']) {
          await store.dispatch('campaign/getCampaignsData');
        }
        next();
      }
    },
    component: () => import('./views/campaigns/campaigns'),
  },
  {
    path: '/offers-board/:id?',
    name: 'offers_board',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        // eslint-disable-next-line no-constant-condition
        if (true || !store.getters['negotiations/hasNegotiationsData']) {
          try {
            store.commit('loader/START_LOADING');
            await store.dispatch('negotiations/getNegotiationsData');
          } catch (e) {
            // TODO
          } finally {
            store.commit('loader/END_LOADING');
          }
        }
        next();
      }
    },
    component: () => import('./views/offersBoard/offersBoard'),
  },
  {
    path: '/content-board/:id?',
    name: 'content_board',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        // eslint-disable-next-line no-constant-condition
        if (true || !store.getters['scheduled/hasAgreedPostsData']) {
          try {
            store.commit('loader/START_LOADING');
            await store.dispatch('scheduled/getAgreedPostsData');
          } catch (e) {
            // TODO
          } finally {
            store.commit('loader/END_LOADING');
          }
        }
        next();
      }
    },
    component: () => import('./views/contentBoard/contentBoard'),
  },
  {
    path: '/pricing',
    name: 'pricing',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['pricing/hasPricing']) {
          await store.dispatch('pricing/getPricePackages');
        }
        next();
      }
    },
    component: () => import('./views/pricing/pricing'),
  },
  {
    path: '/reports',
    name: 'reports',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/reports/reports'),
  },
  {
    path: '/instagram',
    name: 'instagram',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['user/instagramConnected'] && !store.getters['user/hasInstagramData']) {
          await store.dispatch('user/getInstagramData');
        }
        next();
      }
    },
    component: () => import('./views/instagram/instagram')
  },
  {
    path: '/facebook',
    name: 'facebook',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['user/facebookConnected'] && !store.getters['user/hasFacebookData']) {
          await store.dispatch('user/getFacebookData');
        }
        next();
      }
    },
    component: () => import('./views/facebook/facebook'),
  },
  {
    path: '/youtube',
    name: 'youtube',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['user/youtubeConnected'] && !store.getters['user/hasYoutubeData']) {
          await store.dispatch('user/getYoutubeData');
        }
        next();
      }
    },
    component: () => import('./views/youtube/youtube'),
  },
  {
    path: '/blog',
    name: 'blog',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['user/blogConnected'] && !store.getters['user/hasBlogData']) {
          await store.dispatch('user/getBlogData');
        }
        next();
      }
    },
    component: () => import('./views/blog/blog'),
  },
  {
    path: '/setup-influencer',
    name: 'setup-influencer',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {

        if (store.getters['user/setupFinished']) {
          return next({name: store.getters['user/homeRouteName']});
        }

        return next()
      }
    },
    component: () => import('./views/setupInfluencer/setupInfluencer'),
  },
  {
    path: '/profile/:tab?',
    name: 'influencer-profile',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/profile/influencerProfile'),
  },
]
